import {Autocomplete, Pane, SearchInput} from "evergreen-ui";
import React from "react";

function sortStationsNames(stations) {
    return stations.map(
        (station) => '[' + station.idx + '] ' + station.name
    ).sort()
}

export function AutoCompleteMaterials(setStn, stations, stn, onFilterPress) {
    return <Autocomplete
        onSelect={selectedItem => setStn(selectedItem.split("] ")[1])}
        onInputValueChange={val => setStn(val)}
        items={sortStationsNames(stations)}
        selectedItem={stn}
    >
        {({
              key,
              getInputProps,
              getRef,
              inputValue,
              openMenu,
          }) => (
            <Pane key={key} ref={getRef} display="flex">
                <SearchInput
                    onKeyPress={(e) => onFilterPress(e)}
                    flex="1"
                    placeholder="Введите название станции"
                    value={inputValue}
                    onFocus={openMenu}
                    {...getInputProps()}
                />
            </Pane>
        )}
    </Autocomplete>
}